// import React from "react";
// import { Brain, Mic, ScanEye, Sparkles, TriangleAlert } from "lucide-react";
// import { motion } from "framer-motion";
// import PageHero from "../components/common/PageHero";
// import StatGrid from "../components/common/StatGrid";

// export default function SalesAndPurchases() {
//   return (
//     <div className="erp-page-grid">
//       <PageHero
//         badge="AI layer"
//         title="Smarter insights with a calmer, cleaner presentation."
//         subtitle="Forecasts, risk signals and pricing suggestions now live inside a lighter executive workspace instead of a flashy dashboard shell."
//         actions={
//           <>
//             <motion.button
//               className="erp-btn erp-btn-ghost"
//               whileTap={{ scale: 0.97 }}
//             >
//               <Mic size={15} /> Voice entry
//             </motion.button>
//             <motion.button
//               className="erp-btn erp-btn-ghost"
//               whileTap={{ scale: 0.97 }}
//             >
//               <ScanEye size={15} /> Quality vision
//             </motion.button>
//             <motion.button
//               className="erp-btn erp-btn-primary"
//               whileTap={{ scale: 0.97 }}
//             >
//               <Brain size={15} /> Run insights
//             </motion.button>
//           </>
//         }
//       />

//       <StatGrid
//         items={[
//           {
//             title: "Forecasts",
//             value: "14",
//             meta: "Fresh signals generated today",
//             trend: "New",
//             tone: "success",
//             icon: Brain,
//           },
//           {
//             title: "Risk alerts",
//             value: "6",
//             meta: "Need review",
//             trend: "Attention",
//             tone: "warning",
//             icon: TriangleAlert,
//           },
//           {
//             title: "Rate suggestions",
//             value: "18",
//             meta: "Auto-generated opportunities",
//             trend: "Ready",
//             tone: "success",
//             icon: Sparkles,
//           },
//           {
//             title: "Worker anomalies",
//             value: "2",
//             meta: "Pattern deviation detected",
//             trend: "Watch",
//             tone: "warning",
//             icon: ScanEye,
//           },
//         ]}
//       />

//       <div className="erp-grid erp-grid-3">
//         {[
//           [
//             "Demand forecast",
//             "3mm premium oval may tighten in 7 days due to dispatch trend.",
//           ],
//           [
//             "Loss intelligence",
//             "Two MM workers are above the safe weekly rejection band.",
//           ],
//           [
//             "Rate suggestion",
//             "Grade A polished dispatches may support 4–6% higher pricing.",
//           ],
//           [
//             "Bottleneck detection",
//             "MM backlog remains the most active constraint in the chain.",
//           ],
//           [
//             "Approval risk",
//             "Agent B shows high return tendency on medium grade lots.",
//           ],
//           [
//             "Smart reorder",
//             "Suggested raw purchase in amethyst input category within 5 days.",
//           ],
//         ].map(([title, desc]) => (
//           <motion.section
//             className="erp-card"
//             key={title}
//             whileHover={{ y: -4 }}
//             whileTap={{ scale: 0.985 }}
//             initial={{ opacity: 0, y: 16 }}
//             animate={{ opacity: 1, y: 0 }}
//           >
//             <div className="erp-card-head">
//               <div>
//                 <h3>{title}</h3>
//                 <p>{desc}</p>
//               </div>
//               <Sparkles size={18} />
//             </div>
//           </motion.section>
//         ))}
//       </div>

//       <div className="erp-card">
//         <div className="erp-card-head">
//           <div>
//             <h3>Recommendation stream</h3>
//             <p>
//               Suggested next steps shown in a clearer, more business-first
//               interface.
//             </p>
//           </div>
//         </div>
//         <div className="erp-list">
//           {[
//             [
//               "Push premium assorting",
//               "High-grade finish lots are ready for better realization.",
//             ],
//             [
//               "Rebalance MM workers",
//               "A minor reallocation may reduce queue time by afternoon.",
//             ],
//             [
//               "Review Agent B portfolio",
//               "Return pattern suggests a tighter approval mix.",
//             ],
//           ].map(([title, text]) => (
//             <div key={title} className="erp-list-row">
//               <div className="erp-list-icon">
//                 <Sparkles size={14} />
//               </div>
//               <div>
//                 <strong>{title}</strong>
//                 <p>{text}</p>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// }

import React from "react";
import { useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { FileText, ShoppingCart, RotateCcw, Repeat } from "lucide-react";

import PageHero from "../components/common/PageHero";
import StatGrid from "../components/common/StatGrid";
import SalesInvoice from "./salesandpurchase/SalesInvoice";
import PurchaseInvoice from "./salesandpurchase/PurchaseInvoice";
import CreateSalesInvoice from "./salesandpurchase/CreateSalesInvoice";
import CreatePurchaseInvoice from "./salesandpurchase/CreatePurchaseInvoice";
import Target from "./salesandpurchase/Target";
import CompanySales from "./salesandpurchase/CompanySales";
import CreateTarget from "./salesandpurchase/CreateTarget";
import StockTransfer from "./salesandpurchase/StockTransfer";
import CreateAchievement from "./salesandpurchase/CreateAchievement";

// 👇 Child Pages (create these files)

// export default function SalesAndPurchases() {
//   const [searchParams, setSearchParams] = useSearchParams();
//   const view = searchParams.get("view");

//   // 🔥 Mapping (same as Users page)
//   const componentMap = {
//     "sales-invoices": <SalesInvoice />,
//     "create-sales-invoice": <CreateSalesInvoice />,
//     "purchase-invoices": <PurchaseInvoice />,
//     "create-invoice":<CreatePurchaseInvoice/>,
//     targets:<Target/>,
//     "company-sales":<CompanySales/>,
//     CreateTarget:<CreateTarget/>,
//     stocktransfer:<StockTransfer/>
//   };

//   // 👉 If view मौजूद है → child page show करो
//   if (componentMap[view]) {
//     return componentMap[view];
//   }

//   // 👉 Default Dashboard
//   return (
//     <div className="erp-page-grid">
//       {/* HERO */}
//       <PageHero
//         badge="Sales & Purchase"
//         title="Manage Sales & Purchase Operations"
//         subtitle="Create invoices, returns and manage transactions from one place."
//         actions={
//           <>
//             <motion.button
//               className="erp-btn erp-btn-ghost"
//               whileTap={{ scale: 0.97 }}
//               onClick={() => setSearchParams({ view: "sales-invoice" })}
//             >
//               <FileText size={15} /> Sales Invoice
//             </motion.button>

//             <motion.button
//               className="erp-btn erp-btn-ghost"
//               whileTap={{ scale: 0.97 }}
//               onClick={() => setSearchParams({ view: "purchase-invoice" })}
//             >
//               <ShoppingCart size={15} /> Purchase Invoice
//             </motion.button>

//             <motion.button
//               className="erp-btn erp-btn-ghost"
//               whileTap={{ scale: 0.97 }}
//               onClick={() => setSearchParams({ view: "sales-return" })}
//             >
//               <RotateCcw size={15} /> Sales Return
//             </motion.button>

//             <motion.button
//               className="erp-btn erp-btn-primary"
//               whileTap={{ scale: 0.97 }}
//               onClick={() => setSearchParams({ view: "purchase-return" })}
//             >
//               <Repeat size={15} /> Purchase Return
//             </motion.button>
//           </>
//         }
//       />

//       {/* STATS */}
//       <StatGrid
//         items={[
//           {
//             title: "Sales Today",
//             value: "₹1,25,000",
//             meta: "Today's billing",
//             trend: "+8%",
//             tone: "success",
//           },
//           {
//             title: "Purchases",
//             value: "₹82,000",
//             meta: "Stock inflow",
//             trend: "+3%",
//             tone: "success",
//           },
//           {
//             title: "Returns",
//             value: "₹12,500",
//             meta: "Combined returns",
//             trend: "Watch",
//             tone: "warning",
//           },
//           {
//             title: "Pending Payments",
//             value: "₹54,000",
//             meta: "Outstanding",
//             trend: "Alert",
//             tone: "warning",
//           },
//         ]}
//       />

//       {/* QUICK ACTION CARDS */}
//       <div className="erp-grid erp-grid-4">
//         {[
//           {
//             title: "Sales Invoice",
//             desc: "Create new sales bill",
//             view: "sales-invoice",
//             icon: FileText,
//           },
//           {
//             title: "Purchase Invoice",
//             desc: "Add purchase entry",
//             view: "purchase-invoice",
//             icon: ShoppingCart,
//           },
//           {
//             title: "Sales Return",
//             desc: "Manage returned sales",
//             view: "sales-return",
//             icon: RotateCcw,
//           },
//           {
//             title: "Purchase Return",
//             desc: "Manage purchase returns",
//             view: "purchase-return",
//             icon: Repeat,
//           },
//         ].map((item) => {
//           const Icon = item.icon;
//           return (
//             <motion.div
//               key={item.title}
//               className="erp-card"
//               whileHover={{ y: -5 }}
//               whileTap={{ scale: 0.97 }}
//               onClick={() => setSearchParams({ view: item.view })}
//               style={{ cursor: "pointer" }}
//             >
//               <div className="erp-card-head">
//                 <div>
//                   <h3>{item.title}</h3>
//                   <p>{item.desc}</p>
//                 </div>
//                 <Icon size={18} />
//               </div>
//             </motion.div>
//           );
//         })}
//       </div>

//       {/* INFO SECTION */}
//       <div className="erp-card">
//         <div className="erp-card-head">
//           <div>
//             <h3>Smart Insights</h3>
//             <p>Quick highlights from your sales & purchase activity</p>
//           </div>
//         </div>

//         <div className="erp-list">
//           {[
//             [
//               "Sales increasing",
//               "Your sales have grown by 8% compared to yesterday.",
//             ],
//             ["Stock alert", "Some items are nearing minimum stock level."],
//             ["Payment reminder", "₹54,000 pending from customers."],
//           ].map(([title, text]) => (
//             <div key={title} className="erp-list-row">
//               <div className="erp-list-icon">
//                 <FileText size={14} />
//               </div>
//               <div>
//                 <strong>{title}</strong>
//                 <p>{text}</p>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// }
export default function SalesAndPurchases() {
  const [searchParams, setSearchParams] = useSearchParams();
  const view = searchParams.get("view");

  const componentMap = {
    "sales-invoices": <SalesInvoice />,
    "create-sales-invoice": <CreateSalesInvoice />,
    "purchase-invoices": <PurchaseInvoice />,
    "create-invoice": <CreatePurchaseInvoice />,

    // Target
    targets: <Target />,
    CreateTarget: <CreateTarget />,
    CreateAchievement:<CreateAchievement/>,
    stocktransfer: <StockTransfer />,
  };

  // Child page
  if (componentMap[view]) {
    return componentMap[view];
  }

  // Default Dashboard
  return (
    <div className="erp-page-grid">

      {/* HERO */}
      <PageHero
        badge="Sales & Purchase"
        title="Manage Sales & Purchase Operations"
        subtitle="Create invoices, returns and manage transactions from one place."
        actions={
          <>
            <motion.button
              className="erp-btn erp-btn-ghost"
              whileTap={{ scale: 0.97 }}
              onClick={() =>
                setSearchParams({ view: "sales-invoices" })
              }
            >
              <FileText size={15} />
              Sales Invoice
            </motion.button>

            <motion.button
              className="erp-btn erp-btn-ghost"
              whileTap={{ scale: 0.97 }}
              onClick={() =>
                setSearchParams({ view: "purchase-invoices" })
              }
            >
              <ShoppingCart size={15} />
              Purchase Invoice
            </motion.button>

            <motion.button
              className="erp-btn erp-btn-ghost"
              whileTap={{ scale: 0.97 }}
              onClick={() =>
                setSearchParams({ view: "sales-return" })
              }
            >
              <RotateCcw size={15} />
              Sales Return
            </motion.button>

            <motion.button
              className="erp-btn erp-btn-primary"
              whileTap={{ scale: 0.97 }}
              onClick={() =>
                setSearchParams({ view: "purchase-return" })
              }
            >
              <Repeat size={15} />
              Purchase Return
            </motion.button>
          </>
        }
      />

      {/* STATS */}
      <StatGrid
        items={[
          {
            title: "Sales Today",
            value: "₹1,25,000",
            meta: "Today's billing",
            trend: "+8%",
            tone: "success",
          },
          {
            title: "Purchases",
            value: "₹82,000",
            meta: "Stock inflow",
            trend: "+3%",
            tone: "success",
          },
          {
            title: "Returns",
            value: "₹12,500",
            meta: "Combined returns",
            trend: "Watch",
            tone: "warning",
          },
          {
            title: "Pending Payments",
            value: "₹54,000",
            meta: "Outstanding",
            trend: "Alert",
            tone: "warning",
          },
        ]}
      />

      {/* QUICK ACTION CARDS */}
      <div className="erp-grid erp-grid-4">
        {[
          {
            title: "Sales Invoice",
            desc: "Create new sales bill",
            view: "sales-invoices",
            icon: FileText,
          },
          {
            title: "Purchase Invoice",
            desc: "Add purchase entry",
            view: "purchase-invoices",
            icon: ShoppingCart,
          },
          {
            title: "Sales Return",
            desc: "Manage returned sales",
            view: "sales-return",
            icon: RotateCcw,
          },
          {
            title: "Purchase Return",
            desc: "Manage purchase returns",
            view: "purchase-return",
            icon: Repeat,
          },
        ].map((item) => {
          const Icon = item.icon;

          return (
            <motion.div
              key={item.title}
              className="erp-card"
              whileHover={{ y: -5 }}
              whileTap={{ scale: 0.97 }}
              onClick={() =>
                setSearchParams({ view: item.view })
              }
              style={{ cursor: "pointer" }}
            >
              <div className="erp-card-head">
                <div>
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>
                </div>

                <Icon size={18} />
              </div>
            </motion.div>
          );
        })}
      </div>

      {/* INFO SECTION */}
      <div className="erp-card">
        <div className="erp-card-head">
          <div>
            <h3>Smart Insights</h3>
            <p>
              Quick highlights from your sales & purchase activity
            </p>
          </div>
        </div>

        <div className="erp-list">
          {[
            [
              "Sales increasing",
              "Your sales have grown by 8% compared to yesterday.",
            ],
            [
              "Stock alert",
              "Some items are nearing minimum stock level.",
            ],
            [
              "Payment reminder",
              "₹54,000 pending from customers.",
            ],
          ].map(([title, text]) => (
            <div key={title} className="erp-list-row">
              <div className="erp-list-icon">
                <FileText size={14} />
              </div>

              <div>
                <strong>{title}</strong>
                <p>{text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}